<template>
<div class="container1">
    <img class="im_logo" src="/static/imgs/logo_besser.png"/>
</div>
</template>

<script>
import { joiaMixin } from '../scripts/joiaMixin'
import Slider from '@/components/templates/Slider.vue'
import Topbar from '@/components/templates/Topbar.vue'

export default {
    mixins: [joiaMixin],
    data () {
        return {
            name: 'Home',
            base_dir: '/static/products/'
        }
    },
    watch: {
    },
    components: {
        Slider: Slider,
        Topbar: Topbar
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="../css/side_bar.css" scoped/>
<style src="../css/menu_icon.css" scoped/>
<style src="../css/joia.css" scoped/>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue